import React from 'react'

import { useReplies } from './_load/FormReplyLoader'
import DynamicPresentationList from '../../../containers/dynamic/presentationList/DynamicPresentationList'
import Refresher from '../../../packages/kiti/components/helpers/Refresher'

const Content = ({ number }) => {
  const replies = useReplies()

  return (
    <Refresher watch={number}>
      <DynamicPresentationList replies={replies} />
    </Refresher>
  )
}

export default Content
